export enum PanelPlansCharacteristicsSectionsEnum {
    DailyHardBp,
    EquityLeverage,
    TradingPeriod,
    Targets,
    RiskSettings,
    ProhibitedPractises,
    PaidOptions,
    CloseOuts,
    ProfitShare,
    PlansAvailability,
    Tournament
}
